export const ACTION_TYPES = {
    ADD_ORDER: "ADD_ORDER",
    REMOVE_ORDER: "REMOVE_ORDER",
    INCREASE_QUANTITY: "INCREASE_QUANTITY",
    DECREASE_QUANTITY: "DECRASE_QUANTITY",
    GET_PRODUCTS: "GET_PRODUCTS",
    SET_PRODUCTS: "SET_PRODUCTS",
    ERROR_REQUEST: "ERROR_REQUEST",
    SEND_EMAIL: "SEND_EMAIL",
    SEND_EMAIL_RESPONSE: "SEND_EMAIL_RESPONSE",
    SEND_EMAIL_ERROR: "SEND_EMAIL_ERROR",
    OPEN_REVIEW_WINDOW: "OPEN_REVIEW_WINDOW",
    CLOSE_REVIEW_WINDOW: "CLOSE_REVIEW_WINDOW",
    SEND_REVIEW: "SEND_REVIEW",
    SEND_REVIEW_SUCCESS: "SEND_REVIEW_SUCCESS",
    SEND_REVIEW_ERROR: "SEND_REVIEW_ERROR",
    SAVE_DELIVERY_FORM: "SAVE_DELIVERY_FORM",
    SAVE_PAYMENT_FORM: "SAVE_PAYMENT_FORM",
    CLEAR_FORM_DATA: "CLEAR_FORM_DATA",
    CLEAR_CART_ITEMS: "CLEAR_CART_ITEMS",
    ADD_ORDER_FORM_DATA: "ADD_ORDER_FORM_DATA",
    SEND_ORDER: "SEND_ORDER",
    ORDER_RESPONSE: "ORDER_RESPONSE",
    GET_COUNTRIES: "GET_COUNTRIES",
    SET_COUNTRIES: "SET_COUNTRIES",
    GET_CITIES: "GET_CITIES",
    SET_CITIES: "SET_CITIES",
    CLEAR_CITIES: "CLEAR_CITIES",
    COUNTRIES_REQUEST_ERROR: "COUNTRIES_REQUEST_ERROR",
    CITIES_REQUEST_ERROR: "CITIES_REQUEST_ERROR"
};